module.exports = __webpack_public_path__ + "static/media/2-FuentesVargas(1).cbc65f80.png";